module.exports = __webpack_public_path__ + "img/icon3.255d5812.png";